import ToastFeedbackId from '@/constants/ui/ToastFeedbackId';
import type ToastType from '@/constants/ui/ToastType';
import type ToastMessage from '@/types/ToastMessage';
import showFeedbackMessage from './showFeedbackMessage';

export type ShowMessage = Pick<ToastMessage, 'message' | 'containerId'>;

/**
 * Allow for passing either a string or an object as the second parameter.
 *
 * @example showToastTypeMessage(ToastType.SUCCESS, 'FOO')
 * @example showToastTypeMessage(ToastType.SUCCESS, { message: 'FOO', ... });
 */
export default function showWarningMessage(
  type: ToastType,
  param: string | ShowMessage,
) {
  return showFeedbackMessage({
    containerId:
      typeof param === 'object' ? param.containerId : ToastFeedbackId.APP,
    message: typeof param === 'string' ? param : param.message,
    type,
  });
}
